export { cn } from './lib/cn';

// Primitivas
export {
  Button,
  buttonVariants,
  type ButtonProps,
  type ButtonVariant,
  type ButtonSize,
} from './components/button';
export { Input, inputVariants, type InputProps, type InputVariant } from './components/input';
export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
  cardVariants,
  type CardProps,
  type CardVariant,
} from './components/card';
export { Badge, badgeVariants, type BadgeProps, type BadgeVariant } from './components/badge';
export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableRow,
  TableHead,
  TableCell,
  TableCaption,
} from './components/table';
export { SkeletonShimmer, type SkeletonShimmerProps } from './components/skeleton-shimmer';
export { Tabs, TabsList, TabsTrigger, TabsContent } from './components/tabs';

// App composites
export {
  KpiCard,
  type KpiCardProps,
  type KpiVariant,
  type KpiDeltaDirection,
} from './components/kpi-card';
export {
  KpiStatsCard,
  type KpiStatsCardProps,
  type KpiVariant as KpiStatsVariant,
} from './components/kpi-stats-card';
export { KpiRatioCard, type KpiRatioCardProps } from './components/kpi-ratio-card';
export { EmptyState, type EmptyStateProps } from './components/empty-state';
export {
  HealthBanner,
  type HealthBannerProps,
  type HealthBannerVariant,
} from './components/health-banner';

// Layout shells
export { Sidebar, type SidebarProps } from './components/sidebar';
export {
  SidebarNavItem,
  SidebarNavSection,
  type SidebarNavItemProps,
  type SidebarNavSectionProps,
} from './components/sidebar-nav';
export { TopBar, type TopBarProps } from './components/topbar';
export { AppShell, type AppShellProps } from './components/app-shell';
export { MobileDrawer, type MobileDrawerProps } from './components/mobile-drawer';
